import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import TamamlayiciHatirlatma from 'src/components/ComplementaryProductRecommend';
import DataAi from 'src/components/DataAi';
import ExtraWarrantyIncreasePopup from 'src/components/ExtraWarrantyIncreasePopup';
import {
  loadBaslandiJob,
  saveBaslandiJob
} from '../../../utils/storage/StartWorkOrder';
import CustomerInfo from './CustomerInfo';

function Summary({ FisNo, readonly, tasks }) {
  const tasksArray = Array.isArray(tasks?.tasks) ? tasks.tasks : [];

  let customer = readonly
    ? tasksArray.filter(d => Number(d.FisNo) === Number(FisNo))
    : loadBaslandiJob() || [];

  if (!readonly && (!customer || customer.length === 0)) {
    const current = tasks?.tasks?.find(
      d => Number(d.FisNo) === Number(FisNo) && Number(d.DurumKodu) === 33
    );
    if (current) {
      saveBaslandiJob(current);
      customer = loadBaslandiJob();
    }
  }

  const customerData =
    Array.isArray(customer) && customer.length > 0 ? customer[0] : {};

  const hasAiPopup = customerData?.DATAAI === 1;
  const [AiOpen, setAiOpen] = React.useState(hasAiPopup);
  const [
    tamamlayiciUrunHatirlatma,
    setTamamlayiciUrunHatırlatma
  ] = React.useState(
    parseInt(customerData?.TAMAMLAYICI_URUN_HATIRLATMA || 0) === 1
  );

  const warrantyEligible =
    Boolean(customerData?.EKGARANTI_SATISINA_UYGUN_MU) &&
    customerData?.DurumKodu === 33;
  const [warrantyOpen, setWarrantyOpen] = React.useState(false);
  const warrantyShownRef = React.useRef(false);

  React.useEffect(() => {
    // CustomerData tam yüklenene kadar bekle
    if (!customerData?.FisNo) {
      return;
    }

    // Tamamlayıcı ürün popup'ı kapalı olmalı
    const complementaryClosed = !tamamlayiciUrunHatirlatma;

    // DATAAI === 1 ise DataAi popup'ı da kapalı olmalı
    const aiClosed = hasAiPopup ? !AiOpen : true;

    const allPreviousClosed = complementaryClosed && aiClosed;

    if (allPreviousClosed && warrantyEligible && !warrantyShownRef.current) {
      // LocalStorage'dan bu fiş için daha önce gösterilip gösterilmediğini kontrol et
      const alreadyShown = localStorage.getItem(
        `extraWarrantyPopup_${customerData?.FisNo}`
      );
      if (!alreadyShown) {
        warrantyShownRef.current = true;
        setWarrantyOpen(true);
      }
    }
  }, [
    AiOpen,
    tamamlayiciUrunHatirlatma,
    hasAiPopup,
    warrantyEligible,
    customerData?.FisNo
  ]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!customerData || Object.keys(customerData).length === 0) {
    return null;
  }

  return (
    <div>
      <CustomerInfo
        customer={customerData}
        readonly={readonly}
        FisNoParam={FisNo}
      />
      <TamamlayiciHatirlatma
        anketOpen={tamamlayiciUrunHatirlatma}
        setAnketOpen={setTamamlayiciUrunHatırlatma}
        anketTitle="Tamamlayıcı Ürün Önerisi !"
        BASVURU_NO={customerData?.BasvuruNo}
        BIRIM_KODU={customerData?.BIRIM_KODU}
        KUL_MODEL_KODU={customerData?.KUL_MODEL_KODU}
      />
      {customerData?.DATAAI === 1 ? (
        <DataAi
          AiOpen={AiOpen}
          setAiOpen={setAiOpen}
          FisNo={customerData?.FisNo}
          Telefon={customerData?.ArayanTelefonOffline}
        />
      ) : (
        ''
      )}
      <ExtraWarrantyIncreasePopup
        open={warrantyOpen}
        job={customerData}
        onClose={() => setWarrantyOpen(false)}
      />
    </div>
  );
}

Summary.propTypes = {
  className: PropTypes.string,
  FisNo: PropTypes.string,
  tasks: PropTypes.object
};

export default connect(state => ({ tasks: state.tasks1 }))(Summary);
